module.exports = __webpack_public_path__ + "img/1529625119.48ac5fa8.jpg";